import { Iconic } from '@/commons/iconic';
import { Card, Stack } from '@mui/material';

type Props = {
  bgcolor?: string;
  label: string;
  value: string;
  icon: string;
};

export const CardPay = ({ bgcolor, label, value, icon }: Props) => {
  if (!label?.length) return null;

  return (
    <Card
      elevation={5}
      sx={{
        minWidth: { xs: 110, sm: 110, md: 100, xl: 181 },
        height: { xs: 110, sm: 110, md: 100, xl: 181 },
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        background: bgcolor,
        boxShadow: 5,
      }}
    >
      <Stack>
        <Iconic
          sx={{
            width: { xs: 35, sm: 30, md: 30, xl: 50 },
            height: { xs: 35, sm: 30, md: 30, xl: 50 },
          }}
          icon={icon}
        />
      </Stack>
      <Stack fontSize={{ xs: 14, sm: 15, md: 15, xl: '1.5rem' }} fontWeight={700} color="#004B50">
        {value}
      </Stack>
      <Stack fontSize={{ xs: 12, sm: 13, md: 13.5, xl: '1rem' }} fontWeight={700} color="#004B50">
        {label}
      </Stack>
    </Card>
  );
};
